'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Grid3X3, Search, Newspaper, Bookmark } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface NavItem {
  href: string;
  labelHi: string;
  labelEn: string;
  icon: React.ElementType;
}

const NAV_ITEMS: NavItem[] = [
  { href: '/', labelHi: 'होम', labelEn: 'Home', icon: Home },
  { href: '/categories-screen', labelHi: 'श्रेणियाँ', labelEn: 'Categories', icon: Grid3X3 },
  { href: '/news-detail-screen', labelHi: 'ताज़ा', labelEn: 'Latest', icon: Newspaper },
  { href: '#search', labelHi: 'खोज', labelEn: 'Search', icon: Search },
  { href: '#bookmarks', labelHi: 'बुकमार्क', labelEn: 'Saved', icon: Bookmark },
];

interface BottomNavProps {
  lang?: 'hi' | 'en';
}

export default function BottomNav({ lang = 'hi' }: BottomNavProps) {
  const pathname = usePathname();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border bottom-nav-safe lg:hidden">
      <div className="flex items-stretch">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = pathname === item.href || (item.href === '/' && pathname === '/');
          return (
            <Link
              key={`bottom-nav-${item.href}-${item.labelHi}`}
              href={item.href}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors duration-150 ${
                isActive
                  ? 'text-primary' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 1.8} />
              <span className={`text-[9px] font-hindi font-medium leading-none ${isActive ? 'font-semibold' : ''}`}>
                {lang === 'hi' ? item.labelHi : item.labelEn}
              </span>
              {isActive && (
                <span className="absolute bottom-0 w-8 h-0.5 bg-primary rounded-t-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}